import React, { Component } from "react";
import { Chart } from "primereact/chart";
import * as ChartJS from "chart.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { connect } from "react-redux";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { dashboardActions, mappingActions } from "../actions";
import tableRequest from "../models/tableRequest.js";
import "./Sidebar.css";

// Same categorical palette used for the "Top Product Scans" doughnut above,
// extended with its dark-step variants so 12 monthly bars each get a distinct color.
const BAR_3D_PALETTE = [
  "#2a78d6",
  "#eb6834",
  "#1baf7a",
  "#eda100",
  "#e87ba4",
  "#008300",
  "#4a3aa7",
  "#e34948",
  "#3987e5",
  "#d95926",
  "#199e70",
  "#c98500",
];

function getBarColors(count) {
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(BAR_3D_PALETTE[i % BAR_3D_PALETTE.length]);
  }
  return colors;
}

function getMonthlyTransactionChart(items) {
  const monthlyData =
    items?.MonthlyTransactions ||
    items?.MonthlyTransactionList ||
    items?.MonthWiseTransactions ||
    [];

  if (Array.isArray(monthlyData)) {
    return {
      labels: monthlyData.map((item) => item.MonthName || item.Month || item.Label || ""),
      totalTransactions: monthlyData.map((item) => Number(item.TotalTransactions ?? 0)),
      successfulTransactions: monthlyData.map((item) => Number(item.SuccessfulTransactions ?? 0)),
      failedTransactions: monthlyData.map((item) => Number(item.FailedTransactions ?? 0)),
      totalAmount: monthlyData.map((item) => Number(item.TotalAmount ?? 0)),
      successfulAmount: monthlyData.map((item) => Number(item.SuccessfulAmount ?? 0)),
      failedAmount: monthlyData.map((item) => Number(item.FailedAmount ?? 0)),
    };
  }

  if (monthlyData && typeof monthlyData === "object") {
    return {
      labels: Object.keys(monthlyData),
      totalTransactions: Object.values(monthlyData).map((value) => Number(value || 0)),
      successfulTransactions: [],
      failedTransactions: [],
      totalAmount: [],
      successfulAmount: [],
      failedAmount: [],
    };
  }

  return {
    labels: [],
    totalTransactions: [],
    successfulTransactions: [],
    failedTransactions: [],
    totalAmount: [],
    successfulAmount: [],
    failedAmount: [],
  };
}

function shadeHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  const r = (num >> 16) & 0xff;
  const g = (num >> 8) & 0xff;
  const b = num & 0xff;
  const adjust = (c) => Math.min(255, Math.max(0, Math.round(c + (c * percent) / 100)));
  return `rgb(${adjust(r)}, ${adjust(g)}, ${adjust(b)})`;
}

// Draws an extruded top + side face behind each bar to fake a 3D block look.
// Only runs for bar charts that opt in via `options.threeD` so other charts are unaffected.
const bar3dPlugin = {
  id: "bar3d",
  afterDatasetsDraw(chart) {
    const threeD = chart.options && chart.options.threeD;
    if (!threeD || chart.config.type !== "bar") return;
    const depth = threeD.depth || 8;
    const ctx = chart.ctx;

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      if (meta.hidden) return;

      meta.data.forEach((bar) => {
        const vm = bar._view;
        if (!vm || !vm.backgroundColor) return;

        const left = vm.x - vm.width / 2;
        const right = vm.x + vm.width / 2;
        const top = Math.min(vm.y, vm.base);
        const bottom = Math.max(vm.y, vm.base);
        const topColor = shadeHexColor(vm.backgroundColor, 22);
        const sideColor = shadeHexColor(vm.backgroundColor, -28);

        ctx.save();

        ctx.beginPath();
        ctx.moveTo(left, top);
        ctx.lineTo(left + depth, top - depth);
        ctx.lineTo(right + depth, top - depth);
        ctx.lineTo(right, top);
        ctx.closePath();
        ctx.fillStyle = topColor;
        ctx.fill();

        ctx.beginPath();
        ctx.moveTo(right, top);
        ctx.lineTo(right + depth, top - depth);
        ctx.lineTo(right + depth, bottom - depth);
        ctx.lineTo(right, bottom);
        ctx.closePath();
        ctx.fillStyle = sideColor;
        ctx.fill();

        ctx.restore();
      });
    });
  },
};
ChartJS.pluginService.register(bar3dPlugin);

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onLoyaltyPeriodChange = this.onLoyaltyPeriodChange.bind(this);
    this.state = {
       localTransactions: [],
      globalFilter: null,
      first: 0,
      rows: 5,
      totalRecords: 0,
      sortOrder: "",
      loading: false,
    };
    this.state = {
      globalFilter: null,
      loyaltyPeriod: "Today",
    };
    this.tblResponse.LoyaltyFilterType = "Today";
  }

  componentDidMount() {
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        }
      }
    }
    this.setState({ localTransactions: this.props.todayTransactions });
    this.props.fetchApi(this.tblResponse);
    //this.props.fetchMappingApi(this.tblResponse);
  }

  componentDidUpdate(prevProps) {

  
    
    if (this.props.MappingData) {
      if (prevProps.MappingData !== this.props.MappingData) {
        // this.props.myProp has a different value
        if (this.props.MappingData) {
          var e = this.props.MappingData;
          this.setState({
            totalRecords: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }

    if (prevProps.MaxFromNo !== this.props.MaxFromNo) {
      this.setState({
        FromNo: this.props.MaxFromNo,
      });
    }
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  onPage(event) {
    //imitate delay of a backend call
    this.getLazyLoadingValues(event);
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  onLoyaltyPeriodChange(event) {
    const loyaltyPeriod = event.target.value;
    this.setState({ loyaltyPeriod });
    this.tblResponse.LoyaltyFilterType = loyaltyPeriod;
    this.props.fetchApi(this.tblResponse);
  }

  render() {
    const chartdata = {
      labels: this.props.Months,
      datasets: [
        {
          label: "Product Mapping",
          data: this.props.MappingChart,
          fill: false,
          borderColor: "#2a78d6",
        },
        {
          label: "Product De-Mapping",
          data: this.props.DeMappingChart,
          fill: false,
          borderColor: "#eb6834",
        },
      ],
    };

   const { localTransactions } = this.state;
   const monthlyTransactionChart = getMonthlyTransactionChart(this.props.DashboardData);
   const topLoyaltyUsers = (this.props.TopLoyaltyUsers || [])
     .slice()
     .sort(
       (a, b) =>
         Number(b.TotalLoyaltyPoints || 0) -
         Number(a.TotalLoyaltyPoints || 0)
     )
     .slice(0, 10);
    return (
      <main className="mb4">
        <div className="box-shadowe box-space">
          <div
            className="row no-gutters 
          row-cols-1 
          row-cols-md-2 
          row-cols-xl-4
          main-point"
          >
            <a href="activation/issue-number">
              <div className="col toyoBoxDash">
                <div className="card radius-10 box-side1 dashboard-stat-card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Number Issues</p>
                        <h2 className="my-1 dash-stat-value">
                          {" "}
                          {this.props.TotalIssue ? this.props.TotalIssue : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-1 ms-auto">
                        <i className="fa fa-list-ol" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <a href=" transactions/mapping">
              <div className="col toyoBoxDash ">
                <div className="card radius-10 box-side2 dashboard-stat-card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Mapping</p>
                        <h2 className="my-1 dash-stat-value">
                          {" "}
                          {this.props.TotalMapping
                            ? this.props.TotalMapping
                            : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-2 ms-auto">
                        <i className="fa fa-cube" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <a href="/transactions/de-mapping">
              <div className="col toyoBoxDash">
                <div className="card radius-10 box-side3 dashboard-stat-card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">De Mapping</p>
                        <h2 className="my-1 dash-stat-value">
                          {" "}
                          {this.props.TotalDeMapping
                            ? this.props.TotalDeMapping
                            : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-3 ms-auto">
                        <i className="fa fa-cubes" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="masters/user-approval">
              <div className="col toyoBoxDash">
                <div className="card radius-10 box-side-warning dashboard-stat-card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">
                          User Approval Pending{" "}
                        </p>
                        <h2 className="my-1 dash-stat-value">
                          {" "}
                          {this.props.UserPendingApprovel
                            ? this.props.UserPendingApprovel
                            : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-warning ms-auto">
                        <i className="fa fa-user" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <a href="reports/Damage-report">
              <div className="col toyoBoxDash">
                <div className="card radius-10 box-side-critical dashboard-stat-card dashboard-stat-damage">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Damage</p>
                        <h2 className="my-1 dash-stat-value">
                          {this.props.TotalDamage ? this.props.TotalDamage : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-critical ms-auto">
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

               <a href="masters/mobile-user-master">
              <div className="col toyoBoxDash">
                <div className="card radius-10 box-side-critical dashboard-stat-card dashboard-stat-active">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Active Mehanic </p>
                        <h2 className="my-1 dash-stat-value">
                          {this.props.UserMehanic ? this.props.UserMehanic : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-critical ms-auto">
                        <i
                          className="fa fa-users"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>


       
              <div className="col toyoBoxDash">
                <div className="card radius-10 box-side-critical dashboard-stat-card dashboard-stat-inactive">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">InactiveMehanicUser</p>
                        <h2 className="my-1 dash-stat-value">
                          {this.props.InactiveMehanicUser ? this.props.InactiveMehanicUser : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle dash-icon-critical ms-auto">
                        <i
                          className="fa fa-user-times"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
     



            <div className="col toyoBoxDash">
              <div className="card radius-10 box-side4 dashboard-stat-card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div>
                      <p className="mb-0 text-secondary">Total Scans</p>
                      <h2 className="my-1 dash-stat-value">
                        {this.props.TotalScans ? this.props.TotalScans : 0}
                      </h2>
                    </div>
                    <div className="box1 widgets-icons-2 rounded-circle dash-icon-4 ms-auto">
                      <i className="fa fa-qrcode" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <a href="/transactions/damage"></a>
        <div className="row m-top">
          <div className="col-md-6 boxx">
            <div className="cards">
              <h2>Top Product Scans</h2>
              
              <Chart

                type="doughnut"
                data={{
                  labels: this.props.ProductNames,
                  datasets: [
                    {
                      // label: "Products",
                      data: this.props.ScanCounts,
                      backgroundColor: [
                        "#2a78d6",
                        "#eb6834",
                        "#1baf7a",
                        "#eda100",
                        "#e87ba4",
                        "#008300",
                        "#4a3aa7",
                        "#e34948",
                      ],
                      hoverOffset: 4,
                    },
                  ],
                }}
              />
            </div>
          </div>
          <div className="col-md-6 boxx">
            <div className="cards">
              <h2>Product Mappings</h2>
              <Chart
                type="bar"
                data={{
                  labels: this.props.Months,
                  datasets: [
                    {
                      label: "Mappings",
                      data: this.props.MappingChart,
                      backgroundColor: getBarColors(
                        (this.props.Months || []).length
                      ),
                      borderWidth: 0,
                      barPercentage: 0.7,
                      categoryPercentage: 0.7,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  legend: { display: false },
                  threeD: { depth: 8 },
                  scales: {
                    yAxes: [
                      {
                        ticks: { beginAtZero: true },
                      },
                    ],
                  },
                }}
              />
            </div>
          </div>

          <div className="col-md-12 boxx" style={{ order: 1 }}>
            <div className="cards">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2 className="mb-0">Top 10 Loyalty Users Achiever</h2>
                <select
                  className="form-control"
                  style={{ width: "130px" }}
                  value={this.state.loyaltyPeriod}
                  onChange={this.onLoyaltyPeriodChange}
                  aria-label="Loyalty period"
                >
                  <option value="Today">Today</option>
                  <option value="Week">Week</option>
                  <option value="Month">Month</option>
                </select>
              </div>
              {topLoyaltyUsers.length > 0 ? (
                <Chart
                  type="horizontalBar"
                  style={{ height: "320px" }}
                  data={{
                    labels: topLoyaltyUsers.map(
                      (user) => user.UserName || "Unknown User"
                    ),
                    datasets: [
                      {
                        label: "Loyalty Points",
                        data: topLoyaltyUsers.map((user) =>
                          Number(user.TotalLoyaltyPoints || 0)
                        ),
                        backgroundColor: getBarColors(topLoyaltyUsers.length),
                        borderWidth: 0,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { display: false },
                    scales: {
                      xAxes: [
                        {
                          ticks: { beginAtZero: true },
                          gridLines: { color: "rgba(52, 71, 103, 0.08)" },
                        },
                      ],
                      yAxes: [{ gridLines: { display: false } }],
                    },
                    tooltips: {
                      callbacks: {
                        label: (tooltipItem) =>
                          `Loyalty Points: ${Number(
                            tooltipItem.xLabel
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`,
                      },
                    },
                  }}
                />
              ) : (
                <p className="text-muted mb-0">
                  Loyalty users data is not available.
                </p>
              )}
            </div>
          </div>

          <div className="col-md-6 boxx">
            <div className="cards">
              <h2>Monthly Transaction Status</h2>
              {monthlyTransactionChart.labels.length > 0 ? (
                <Chart
                  type="bar"
                  data={{
                    labels: monthlyTransactionChart.labels,
                    datasets: [
                      {
                        label: "Total",
                        data: monthlyTransactionChart.totalTransactions,
                        type: "line",
                        borderColor: "#2a78d6",
                        backgroundColor: "rgba(42, 120, 214, 0.08)",
                        pointBackgroundColor: "#2a78d6",
                        pointBorderColor: "#ffffff",
                        pointBorderWidth: 2,
                        pointRadius: 4,
                        borderWidth: 3,
                        fill: false,
                        lineTension: 0.35,
                        order: 0,
                      },
                      {
                        label: "Successful",
                        data: monthlyTransactionChart.successfulTransactions,
                        backgroundColor: "#1baf7a",
                        borderRadius: 6,
                        stack: "transactions",
                        order: 1,
                      },
                      {
                        label: "Failed",
                        data: monthlyTransactionChart.failedTransactions,
                        backgroundColor: "#e34948",
                        borderRadius: 6,
                        stack: "transactions",
                        order: 1,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    legend: { display: true, position: "bottom" },
                    tooltips: { mode: "index", intersect: false },
                    scales: {
                      xAxes: [{ stacked: true, gridLines: { display: false } }],
                      yAxes: [
                        {
                          stacked: true,
                          ticks: { beginAtZero: true, precision: 0 },
                          gridLines: { color: "rgba(52, 71, 103, 0.08)" },
                        },
                      ],
                    },
                  }}
                />
              ) : (
                <p className="text-muted mb-0">
                  Monthly transaction data is not available.
                </p>
              )}
            </div>
          </div>

          <div className="col-md-6 boxx">
            <div className="cards">
              <h2>Monthly Transfer Amount</h2>
              {monthlyTransactionChart.labels.length > 0 ? (
                <Chart
                  type="line"
                  data={{
                    labels: monthlyTransactionChart.labels,
                    datasets: [
                      {
                        label: "Total Amount",
                        data: monthlyTransactionChart.totalAmount,
                        borderColor: "#2a78d6",
                        backgroundColor: "rgba(42, 120, 214, 0.1)",
                        fill: false,
                      },
                      {
                        label: "Successful Amount",
                        data: monthlyTransactionChart.successfulAmount,
                        borderColor: "#1baf7a",
                        backgroundColor: "rgba(27, 175, 122, 0.1)",
                        fill: false,
                      },
                      {
                        label: "Failed Amount",
                        data: monthlyTransactionChart.failedAmount,
                        borderColor: "#e34948",
                        backgroundColor: "rgba(227, 73, 72, 0.1)",
                        fill: false,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    legend: { display: true, position: "bottom" },
                    tooltips: {
                      callbacks: {
                        label: (tooltipItem, data) =>
                          `${data.datasets[tooltipItem.datasetIndex].label}: ₹${Number(tooltipItem.yLabel).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
                      },
                    },
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            beginAtZero: true,
                            callback: (value) => `₹${Number(value).toLocaleString("en-IN")}`,
                          },
                        },
                      ],
                    },
                  }}
                />
              ) : (
                <p className="text-muted mb-0">Monthly amount data is not available.</p>
              )}
            </div>
          </div>

<div className="mx-auto p-4" style={{ width: "100%", order: 2 }}>
  <div className="tnx-card">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h2 className="text-xl font-bold">Today's Last 25 Transactions</h2>
      <h6 className="text-lg font-semibold">
        Today Total Transactions: <b>{this.props.TodayTnx ? this.props.TodayTnx : 0}</b>
      </h6>
    </div>
    {this.props.TodayTransactions?.length > 0 ? (
      <div className="tnx-table-scroll">
        <table className="tnx-table">
          <thead>
            <tr>
              <th>Unique Request No</th>
              <th>Payment Mode</th>
              <th>Beneficiary</th>
              <th>Mobile No</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.props.TodayTransactions.map((item, index) => (
              <tr key={index}>
                <td>{item.UniqueRequestNumber}</td>
                <td>{item.PaymentMode}</td>
                <td>{item.BeneficiaryName}</td>
                <td>{item.MobileNo}</td>
                <td>{item.Amount}</td>
                <td>{item.Status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="text-gray-500">No transactions found for today.</p>
    )}
    <p className="mb-0 mt-2" style={{ fontSize: "13px", fontWeight: "500", color: "#6c757d" }}>
      Note: These transactions are shown from the EaseBuzz response.
    </p>
  </div>
</div>



        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state.dashboard?.items?.DashboardCount?.InactiveMehanicUser);
  return {
    DashboardData: state.dashboard?.items,
    DashboardList: state.dashboard?.items?.DashboardListData,
    TotalMapping: state.dashboard?.items?.DashboardCount?.TotalMapping,
    TotalDeMapping: state.dashboard?.items?.DashboardCount?.TotalDeMapping,
    UserPendingApprovel:state.dashboard?.items?.DashboardCount?.UserPendingApprovel,
    TotalDamage: state.dashboard?.items?.DashboardCount?.TotalDamage,
    TodayTnx:state.dashboard?.items?.DashboardCount?.TodayTnx,
    TotalScans: state.dashboard?.items?.DashboardCount?.TotalScans,
    TotalIssue: state.dashboard?.items?.DashboardCount?.TotalIssue,
    DeMappingChart: state.dashboard?.items?.DeMappingList,
    MappingChart: state.dashboard?.items?.MappingList,
    ProductNames: state.dashboard?.items?.ProductNames,
    ScanCounts: state.dashboard?.items?.ScanCounts,
    Months: state.dashboard?.items?.MonthName,
    MappingData: state.mapping.items,
    TodayTransactions: state.dashboard?.items?.TodayTransactions,
    TopLoyaltyUsers: state.dashboard?.items?.TopLoyaltyUsers,
    InactiveMehanicUser:
      state.dashboard?.items?.DashboardCount?.InactiveMehanicUser,
    UserMehanic: state.dashboard?.items?.DashboardCount?.UserMehanic,

    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(dashboardActions.fetchData(obj));
    },
    fetchMappingApi: (obj) => {
      dispatch(mappingActions.getAll(obj));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
